import styles from '../../ApplicationInformation.module.scss';
import classNames from 'classnames';
import BulkSelectModal from '../../../../components/UI/BulkSelectModal/BulkSelectModal';
import { useEffect, useState } from 'react';
import { GetContactOptions } from '../../ApplicationInformation_api';
import { Tooltip } from '../../../../components/UI/MDC/Tooltip/Tooltip';
import MaterialIcon from '@material/react-material-icon';

const ContactsEdit = ({
	copyOfApp,
	setCopyOfApp,
	contactTypeKey,
	buttonLabel,
}) => {
	const [contactOptions, setContactOptions] = useState([]);
	const [formattedOptions, setFormattedOptions] = useState([]);
	const [currentSelections, setCurrentSelections] = useState(null);
	const [optionsLoading, setOptionsLoading] = useState(false);

	const [contactsData, setContactsData] = useState([
		...copyOfApp.appInfo[contactTypeKey].contactData,
	]);
	const [formattedContactsData, setFormattedContactsData] = useState([]);

	const initialSelectedOptions = [
		...copyOfApp.appInfo[contactTypeKey].contactData,
	];

	useEffect(() => {
		let formattedData = contactsData.map(x => {
			return {
				...x,
				Extras: (
					<>
						<Tooltip
							content={
								<div className={styles.toolTip_Content}>
									<p>NetworkID: {x.NTID}</p>
									<p>Familiar ESO ID: {x.Familiar_ESO}</p>
								</div>
							}
						>
							<MaterialIcon
								icon='info'
								className={styles.tooltip_Icon}
							/>
						</Tooltip>
					</>
				),
			};
		});
		setFormattedContactsData(formattedData);
	}, [contactsData]);

	useEffect(() => {
		setFormattedOptions(
			contactOptions?.map(opt => {
				return {
					ID: opt.ID,
					Name: opt.Name,
					ESOID: opt.ESOID,
					Extras: (
						<>
							<Tooltip
								content={
									<div className={styles.toolTip_Content}>
										<p>NetworkID: {opt.NetworkID}</p>
										<p>
											Familiar ESO ID: {opt.FamiliarESOID}
										</p>
									</div>
								}
							>
								<MaterialIcon
									icon='info'
									className={styles.tooltip_Icon}
								/>
							</Tooltip>
						</>
					),
				};
			})
		);
	}, [contactOptions]);

	const handleSearch = searchTerm => {
		if (searchTerm.length >= 1) {
			setOptionsLoading(true);
			GetContactOptions(searchTerm).then(response => {
				if (response.length) {
					setContactOptions(response);
				} else {
					setContactOptions([]);
				}
				setOptionsLoading(false);
			});
		} else {
			setContactOptions([]);
		}
	};

	const handleChange = updatedContacts => {
		setContactsData(updatedContacts);
		setCurrentSelections(updatedContacts.map(x => x.Name).join(', '));
	};

	const setAppContacts = () => {
		let updatedApp = { ...copyOfApp };
		updatedApp.appInfo[contactTypeKey].contactData = contactsData;
		updatedApp.appInfo[contactTypeKey].displayFormattedLocations =
			contactsData
				.map(x => {
					return x.Name;
				})
				.join(', ');
		setCopyOfApp(updatedApp);
	};

	const getCurrentSelections = () => {
		if (currentSelections === null) {
			return copyOfApp.appInfo[contactTypeKey].displayFormattedContacts;
		} else {
			return currentSelections;
		}
	};

	return (
		<div className={classNames([styles.hFull, styles.detailInfo])}>
			<div className={styles.locationsEdit}>
				<BulkSelectModal
					options={formattedOptions}
					selected={formattedContactsData}
					handleSearchProp={searchTerm => handleSearch(searchTerm)}
					initialSelections={initialSelectedOptions}
					optionLabelKey={'Name'}
					optionExtrasKey={'Extras'}
					uniqueIdentifierKey={'ID'}
					buttonLabel={buttonLabel}
					onChange={handleChange}
					onDone={setAppContacts}
					optionsPlaceholder='Too many results... modify search'
					optionsLoading={optionsLoading}
					searchDisabled={optionsLoading}
				/>
				<p className={styles.margin_top}>{getCurrentSelections()}</p>
			</div>
		</div>
	);
};

export default ContactsEdit;
